import "core-js/modules/es6.regexp.replace";
import _toArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toArray";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

var _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(_check);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * Convert a validation result to an iterable of failures.
 */


function toFailures(result, context) {
  if (result === true) {
    return [];
  } else if (result === false) {
    return [context.fail()];
  } else {
    return result;
  }
}
/**
 * `Struct` objects encapsulate the schema for a specific data type (with
 * optional coercion). You can then use the `assert`, `is` or `validate` helpers
 * to validate unknown data against a struct.
 */


var Struct = function Struct(props) {
  _classCallCheck(this, Struct);

  var type = props.type,
      schema = props.schema,
      _props$coercer = props.coercer,
      coercer = _props$coercer === void 0 ? function (value) {
    return value;
  } : _props$coercer,
      _props$validator = props.validator,
      validator = _props$validator === void 0 ? function () {
    return [];
  } : _props$validator,
      _props$refiner = props.refiner,
      refiner = _props$refiner === void 0 ? function () {
    return [];
  } : _props$refiner;
  this.type = type;
  this.schema = schema;
  this.coercer = coercer;
  this.validator = validator;
  this.refiner = refiner;
};
/**
 * `StructError` objects are thrown (or returned) by Superstruct when its
 * validation fails. The error represents the first error encountered during
 * validation. But they also have an `error.failures` property that holds
 * information for all of the failures encountered.
 */


var StructError = /*#__PURE__*/function (_TypeError) {
  _inherits(StructError, _TypeError);

  function StructError(failure, iterable) {
    var _this;

    var _marked = /*#__PURE__*/_regeneratorRuntime.mark(failures);

    _classCallCheck(this, StructError);

    var path = failure.path,
        value = failure.value,
        type = failure.type,
        branch = failure.branch,
        rest = _objectWithoutProperties(failure, ["path", "value", "type", "branch"]);

    var message = "Expected a value of type `".concat(type, "`").concat(path.length ? " for `".concat(path.join('.'), "`") : '', " but received `").concat(JSON.stringify(value), "`.");

    function failures() {
      return _regeneratorRuntime.wrap(function failures$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return failure;

            case 2:
              return _context.delegateYield(iterable, "t0", 3);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _marked);
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StructError).call(this, message));
    _this.value = value;
    Object.assign(_assertThisInitialized(_this), rest);
    _this.type = type;
    _this.path = path;
    _this.branch = branch;
    _this.failures = failures;
    _this.stack = new Error().stack;
    _this.__proto__ = StructError.prototype;
    return _this;
  }

  return StructError;
}( /*#__PURE__*/_wrapNativeSuper(TypeError));
/**
 * Assert that a value passes a `Struct`, throwing if it doesn't.
 */


function assert(value, struct) {
  var result = validate(value, struct);

  if (result[0]) {
    throw result[0];
  }
}
/**
 * Coerce a value with the coercion logic of `Struct` and validate it.
 */


function coerce(value, struct) {
  var ret = struct.coercer(value);
  assert(ret, struct);
  return ret;
}
/**
 * Check if a value passes a `Struct`.
 */


function is(value, struct) {
  var result = validate(value, struct);
  return !result[0];
}
/**
 * Validate a value against a `Struct`, returning an error if invalid.
 */


function validate(value, struct) {
  var coercing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (coercing) {
    value = struct.coercer(value);
  }

  var iterable = _check(value, struct);

  var _iterable = _slicedToArray(iterable, 1),
      failure = _iterable[0];

  if (failure) {
    var error = new StructError(failure, iterable);
    return [error, undefined];
  } else {
    return [undefined, value];
  }
}
/**
 * Check a value against a `Struct`, returning an iterable of failures.
 */


function _check(value, struct) {
  var path,
      branch,
      type,
      ctx,
      failures,
      _failures,
      failure,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function _check$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          path = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
          branch = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : [];
          type = struct.type;
          ctx = {
            value: value,
            type: type,
            branch: branch,
            path: path,
            fail: function fail() {
              var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return _objectSpread2({
                value: value,
                type: type,
                path: path,
                branch: [].concat(_toConsumableArray(branch), [value])
              }, props);
            },
            check: function check(v, s, parent, key) {
              var p = parent !== undefined ? [].concat(_toConsumableArray(path), [key]) : path;
              var b = parent !== undefined ? [].concat(_toConsumableArray(branch), [parent]) : branch;
              return _check(v, s, p, b);
            }
          };
          failures = toFailures(struct.validator(value, ctx), ctx);
          _failures = _slicedToArray(failures, 1), failure = _failures[0];

          if (!failure) {
            _context2.next = 12;
            break;
          }

          _context2.next = 9;
          return failure;

        case 9:
          return _context2.delegateYield(failures, "t0", 10);

        case 10:
          _context2.next = 13;
          break;

        case 12:
          return _context2.delegateYield(toFailures(struct.refiner(value, ctx), ctx), "t1", 13);

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 */


function coercion(struct, _coercer) {
  var fn = struct.coercer;
  return new Struct(_objectSpread2(_objectSpread2({}, struct), {}, {
    coercer: function coercer(value) {
      return fn(_coercer(value));
    }
  }));
}
/**
 * Augment a struct to coerce a default value for missing values.
 *
 * Note: You must use `coerce(value, Struct)` on the value before validating it
 * to have the value defaulted!
 */


function defaulted(S, fallback, strict) {
  return coercion(S, function (x) {
    var f = typeof fallback === 'function' ? fallback() : fallback;

    if (x === undefined) {
      return f;
    }

    if (strict !== true && isPlainObject(x) && isPlainObject(f)) {
      var ret = _objectSpread2({}, x);

      var changed = false;

      for (var key in f) {
        if (ret[key] === undefined) {
          ret[key] = f[key];
          changed = true;
        }
      }

      if (changed) {
        return ret;
      }
    }

    return x;
  });
}
/**
 * Coerce a value to mask its properties to only that defined in the struct.
 */


function masked(S) {
  return coercion(S, function (x) {
    if (!isPlainObject(x)) {
      return x;
    }

    var ret = {};

    for (var key in S.schema) {
      ret[key] = x[key];
    }

    return ret;
  });
}
/**
 * Check if a value is a plain object.
 */


function isPlainObject(value) {
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Augment a string or array struct to constrain its length to zero.
 */


function empty(S) {
  return refinement(S, "".concat(S.type, " & Empty"), function (value) {
    return value.length === 0;
  });
}
/**
 * Augment a string or array struct to constrain its length to being between a
 * minimum and maximum size.
 */


function length(S, min, max) {
  return refinement(S, "".concat(S.type, " & Length<").concat(min, ",").concat(max, ">"), function (value) {
    return min < value.length && value.length < max;
  });
}
/**
 * Refine a string struct to match a specific regexp pattern.
 */


function pattern(S, regexp) {
  return refinement(S, "".concat(S.type, " & Pattern<").concat(regexp.source, ">"), function (value) {
    return regexp.test(value);
  });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 */


function refinement(struct, type, _refiner) {
  var fn = struct.refiner;
  return new Struct(_objectSpread2(_objectSpread2({}, struct), {}, {
    type: type,
    refiner: /*#__PURE__*/_regeneratorRuntime.mark(function refiner(value, fail) {
      return _regeneratorRuntime.wrap(function refiner$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.delegateYield(toFailures(fn(value, fail), fail), "t0", 1);

            case 1:
              return _context3.delegateYield(toFailures(_refiner(value, fail), fail), "t1", 2);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, refiner);
    })
  }));
}
/**
 * Validate any value.
 */


function any() {
  return struct('any', function () {
    return true;
  });
}

function array(Element) {
  return new Struct({
    type: "Array<".concat(Element ? Element.type : 'unknown', ">"),
    schema: Element,
    coercer: function coercer(value) {
      return Element && Array.isArray(value) ? value.map(function (v) {
        return coerce(v, Element);
      }) : value;
    },
    validator: /*#__PURE__*/_regeneratorRuntime.mark(function validator(value, ctx) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, i, v;

      return _regeneratorRuntime.wrap(function validator$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (Array.isArray(value)) {
                _context4.next = 4;
                break;
              }

              _context4.next = 3;
              return ctx.fail();

            case 3:
              return _context4.abrupt("return");

            case 4:
              if (!Element) {
                _context4.next = 30;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context4.prev = 8;
              _iterator = value.entries()[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context4.next = 16;
                break;
              }

              _step$value = _slicedToArray(_step.value, 2), i = _step$value[0], v = _step$value[1];
              return _context4.delegateYield(ctx.check(v, Element, value, i), "t0", 13);

            case 13:
              _iteratorNormalCompletion = true;
              _context4.next = 10;
              break;

            case 16:
              _context4.next = 22;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t1 = _context4["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context4.t1;

            case 22:
              _context4.prev = 22;
              _context4.prev = 23;

              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }

            case 25:
              _context4.prev = 25;

              if (!_didIteratorError) {
                _context4.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context4.finish(25);

            case 29:
              return _context4.finish(22);

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, validator, null, [[8, 18, 22, 30], [23,, 25, 29]]);
    })
  });
}
/**
 * Validate that boolean values.
 */


function _boolean() {
  return struct('boolean', function (value) {
    return typeof value === 'boolean';
  });
}
/**
 * Validate that `Date` values.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */


function date() {
  return struct('Date', function (value) {
    return value instanceof Date && !isNaN(value.getTime());
  });
}
/**
 * Validate that a value dynamically, determing which struct to use at runtime.
 */


function dynamic(fn) {
  return struct('Dynamic<...>', function (value, ctx) {
    return ctx.check(value, fn(value, ctx));
  });
}

function enums(values) {
  return struct("Enum<".concat(values.map(toLiteralString), ">"), function (value) {
    return values.includes(value);
  });
}
/**
 * Validate that a value is a function.
 */


function func() {
  return struct('Function', function (value) {
    return typeof value === 'function';
  });
}
/**
 * Validate that a value is an instance of a class.
 */


function instance(Class) {
  return struct("InstanceOf<".concat(Class.name, ">"), function (value) {
    return value instanceof Class;
  });
}

function intersection(Structs) {
  return struct(Structs.map(function (s) {
    return s.type;
  }).join(' & '), /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, ctx) {
    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, S;

    return _regeneratorRuntime.wrap(function _callee$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context5.prev = 3;
            _iterator2 = Structs[Symbol.iterator]();

          case 5:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context5.next = 11;
              break;
            }

            S = _step2.value;
            return _context5.delegateYield(ctx.check(value, S), "t0", 8);

          case 8:
            _iteratorNormalCompletion2 = true;
            _context5.next = 5;
            break;

          case 11:
            _context5.next = 17;
            break;

          case 13:
            _context5.prev = 13;
            _context5.t1 = _context5["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context5.t1;

          case 17:
            _context5.prev = 17;
            _context5.prev = 18;

            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }

          case 20:
            _context5.prev = 20;

            if (!_didIteratorError2) {
              _context5.next = 23;
              break;
            }

            throw _iteratorError2;

          case 23:
            return _context5.finish(20);

          case 24:
            return _context5.finish(17);

          case 25:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee, null, [[3, 13, 17, 25], [18,, 20, 24]]);
  }));
}
/**
 * Validate a value lazily, by constructing the struct right before the first
 * validation. This is useful for cases where you want to have self-referential
 * structs for nested data structures.
 */


function lazy(fn) {
  var S;
  return struct('Lazy<...>', function (value, ctx) {
    if (!S) {
      S = fn();
    }

    return ctx.check(value, S);
  });
}

function literal(constant) {
  return struct("Literal<".concat(toLiteralString(constant), ">"), function (value) {
    return value === constant;
  });
}
/**
 * Validate that a value is a map with specific key and value entries.
 */


function map(Key, Value) {
  return struct("Map<".concat(Key.type, ",").concat(Value.type, ">"), /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value, ctx) {
    var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step3$value, k, v;

    return _regeneratorRuntime.wrap(function _callee2$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (value instanceof Map) {
              _context6.next = 4;
              break;
            }

            _context6.next = 3;
            return ctx.fail();

          case 3:
            return _context6.abrupt("return");

          case 4:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context6.prev = 7;
            _iterator3 = value.entries()[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              _context6.next = 16;
              break;
            }

            _step3$value = _slicedToArray(_step3.value, 2), k = _step3$value[0], v = _step3$value[1];
            return _context6.delegateYield(ctx.check(k, Key, value, k), "t0", 12);

          case 12:
            return _context6.delegateYield(ctx.check(v, Value, value, k), "t1", 13);

          case 13:
            _iteratorNormalCompletion3 = true;
            _context6.next = 9;
            break;

          case 16:
            _context6.next = 22;
            break;

          case 18:
            _context6.prev = 18;
            _context6.t2 = _context6["catch"](7);
            _didIteratorError3 = true;
            _iteratorError3 = _context6.t2;

          case 22:
            _context6.prev = 22;
            _context6.prev = 23;

            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }

          case 25:
            _context6.prev = 25;

            if (!_didIteratorError3) {
              _context6.next = 28;
              break;
            }

            throw _iteratorError3;

          case 28:
            return _context6.finish(25);

          case 29:
            return _context6.finish(22);

          case 30:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee2, null, [[7, 18, 22, 30], [23,, 25, 29]]);
  }));
}
/**
 * Validate that a value always fails.
 */


function never() {
  return struct('never', function () {
    return false;
  });
}
/**
 * Augment a struct to make it accept `null` values.
 */


function nullable(S) {
  return new Struct({
    type: "".concat(S.type, " | null"),
    schema: S.schema,
    validator: function validator(value, ctx) {
      return value === null || ctx.check(value, S);
    }
  });
}
/**
 * Validate that a value is a number.
 */


function number() {
  return struct("number", function (value) {
    return typeof value === 'number' && !isNaN(value);
  });
}

function object(Structs) {
  var knowns = Structs ? Object.keys(Structs) : [];
  var Never = never();
  return new Struct({
    type: Structs ? "Object<{".concat(knowns.join(','), "}>") : 'Object',
    schema: Structs ? Structs : null,
    coercer: Structs ? createObjectCoercer(Structs) : function (x) {
      return x;
    },
    validator: /*#__PURE__*/_regeneratorRuntime.mark(function validator(value, ctx) {
      var unknowns, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, key, Value, v, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _key, _v;

      return _regeneratorRuntime.wrap(function validator$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(typeof value !== 'object' || value == null)) {
                _context7.next = 4;
                break;
              }

              _context7.next = 3;
              return ctx.fail();

            case 3:
              return _context7.abrupt("return");

            case 4:
              if (!Structs) {
                _context7.next = 60;
                break;
              }

              unknowns = new Set(Object.keys(value));
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context7.prev = 9;
              _iterator4 = knowns[Symbol.iterator]();

            case 11:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context7.next = 20;
                break;
              }

              key = _step4.value;
              unknowns["delete"](key);
              Value = Structs[key];
              v = value[key];
              return _context7.delegateYield(ctx.check(v, Value, value, key), "t0", 17);

            case 17:
              _iteratorNormalCompletion4 = true;
              _context7.next = 11;
              break;

            case 20:
              _context7.next = 26;
              break;

            case 22:
              _context7.prev = 22;
              _context7.t1 = _context7["catch"](9);
              _didIteratorError4 = true;
              _iteratorError4 = _context7.t1;

            case 26:
              _context7.prev = 26;
              _context7.prev = 27;

              if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                _iterator4["return"]();
              }

            case 29:
              _context7.prev = 29;

              if (!_didIteratorError4) {
                _context7.next = 32;
                break;
              }

              throw _iteratorError4;

            case 32:
              return _context7.finish(29);

            case 33:
              return _context7.finish(26);

            case 34:
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context7.prev = 37;
              _iterator5 = unknowns[Symbol.iterator]();

            case 39:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context7.next = 46;
                break;
              }

              _key = _step5.value;
              _v = value[_key];
              return _context7.delegateYield(ctx.check(_v, Never, value, _key), "t2", 43);

            case 43:
              _iteratorNormalCompletion5 = true;
              _context7.next = 39;
              break;

            case 46:
              _context7.next = 52;
              break;

            case 48:
              _context7.prev = 48;
              _context7.t3 = _context7["catch"](37);
              _didIteratorError5 = true;
              _iteratorError5 = _context7.t3;

            case 52:
              _context7.prev = 52;
              _context7.prev = 53;

              if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                _iterator5["return"]();
              }

            case 55:
              _context7.prev = 55;

              if (!_didIteratorError5) {
                _context7.next = 58;
                break;
              }

              throw _iteratorError5;

            case 58:
              return _context7.finish(55);

            case 59:
              return _context7.finish(52);

            case 60:
            case "end":
              return _context7.stop();
          }
        }
      }, validator, null, [[9, 22, 26, 34], [27,, 29, 33], [37, 48, 52, 60], [53,, 55, 59]]);
    })
  });
}
/**
 * Augment a struct to make it optionally accept `undefined` values.
 */


function optional(S) {
  return new Struct({
    type: "".concat(S.type, "?"),
    schema: S.schema,
    validator: function validator(value, ctx) {
      return value === undefined || ctx.check(value, S);
    }
  });
}
/**
 * Validate that a partial object with specific entry values.
 */


function partial(Structs) {
  if (Structs instanceof Struct) {
    Structs = Structs.schema;
  }

  var knowns = Object.keys(Structs);
  var Never = never();
  return new Struct({
    type: "Partial<{".concat(knowns.join(','), "}>"),
    schema: Structs,
    coercer: createObjectCoercer(Structs),
    validator: /*#__PURE__*/_regeneratorRuntime.mark(function validator(value, ctx) {
      var unknowns, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, key, Value, v, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _key2, _v2;

      return _regeneratorRuntime.wrap(function validator$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(typeof value !== 'object' || value == null)) {
                _context8.next = 4;
                break;
              }

              _context8.next = 3;
              return ctx.fail();

            case 3:
              return _context8.abrupt("return");

            case 4:
              unknowns = new Set(Object.keys(value));
              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context8.prev = 8;
              _iterator6 = knowns[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                _context8.next = 21;
                break;
              }

              key = _step6.value;
              unknowns["delete"](key);

              if (key in value) {
                _context8.next = 15;
                break;
              }

              return _context8.abrupt("continue", 18);

            case 15:
              Value = Structs[key];
              v = value[key];
              return _context8.delegateYield(ctx.check(v, Value, value, key), "t0", 18);

            case 18:
              _iteratorNormalCompletion6 = true;
              _context8.next = 10;
              break;

            case 21:
              _context8.next = 27;
              break;

            case 23:
              _context8.prev = 23;
              _context8.t1 = _context8["catch"](8);
              _didIteratorError6 = true;
              _iteratorError6 = _context8.t1;

            case 27:
              _context8.prev = 27;
              _context8.prev = 28;

              if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                _iterator6["return"]();
              }

            case 30:
              _context8.prev = 30;

              if (!_didIteratorError6) {
                _context8.next = 33;
                break;
              }

              throw _iteratorError6;

            case 33:
              return _context8.finish(30);

            case 34:
              return _context8.finish(27);

            case 35:
              _iteratorNormalCompletion7 = true;
              _didIteratorError7 = false;
              _iteratorError7 = undefined;
              _context8.prev = 38;
              _iterator7 = unknowns[Symbol.iterator]();

            case 40:
              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                _context8.next = 47;
                break;
              }

              _key2 = _step7.value;
              _v2 = value[_key2];
              return _context8.delegateYield(ctx.check(_v2, Never, value, _key2), "t2", 44);

            case 44:
              _iteratorNormalCompletion7 = true;
              _context8.next = 40;
              break;

            case 47:
              _context8.next = 53;
              break;

            case 49:
              _context8.prev = 49;
              _context8.t3 = _context8["catch"](38);
              _didIteratorError7 = true;
              _iteratorError7 = _context8.t3;

            case 53:
              _context8.prev = 53;
              _context8.prev = 54;

              if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                _iterator7["return"]();
              }

            case 56:
              _context8.prev = 56;

              if (!_didIteratorError7) {
                _context8.next = 59;
                break;
              }

              throw _iteratorError7;

            case 59:
              return _context8.finish(56);

            case 60:
              return _context8.finish(53);

            case 61:
            case "end":
              return _context8.stop();
          }
        }
      }, validator, null, [[8, 23, 27, 35], [28,, 30, 34], [38, 49, 53, 61], [54,, 56, 60]]);
    })
  });
}
/**
 * Validate that a value is a record with specific key and
 * value entries.
 */


function record(Key, Value) {
  return struct("Record<".concat(Key.type, ",").concat(Value.type, ">"), /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value, ctx) {
    var k, v;
    return _regeneratorRuntime.wrap(function _callee3$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(typeof value !== 'object' || value == null)) {
              _context9.next = 4;
              break;
            }

            _context9.next = 3;
            return ctx.fail();

          case 3:
            return _context9.abrupt("return");

          case 4:
            _context9.t0 = _regeneratorRuntime.keys(value);

          case 5:
            if ((_context9.t1 = _context9.t0()).done) {
              _context9.next = 12;
              break;
            }

            k = _context9.t1.value;
            v = value[k];
            return _context9.delegateYield(ctx.check(k, Key, value, k), "t2", 9);

          case 9:
            return _context9.delegateYield(ctx.check(v, Value, value, k), "t3", 10);

          case 10:
            _context9.next = 5;
            break;

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee3);
  }));
}
/**
 * Validate that a set of values matches a specific type.
 */


function set(Element) {
  return struct("Set<".concat(Element.type, ">"), function (value, ctx) {
    if (!(value instanceof Set)) {
      return false;
    }

    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = value[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var val = _step8.value;

        var _ctx$check = ctx.check(val, Element),
            _ctx$check2 = _slicedToArray(_ctx$check, 1),
            failure = _ctx$check2[0];

        if (failure) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8["return"] != null) {
          _iterator8["return"]();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    return true;
  });
}
/**
 * Validate that a value is a string.
 */


function string() {
  return struct('string', function (value) {
    return typeof value === 'string';
  });
}
/**
 * Define a `Struct` instance with a type and validation function.
 */


function struct(name, validator) {
  return new Struct({
    type: name,
    validator: validator,
    schema: null
  });
}

function tuple(Elements) {
  var Never = never();
  return struct("[".concat(Elements.map(function (s) {
    return s.type;
  }).join(','), "]"), /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value, ctx) {
    var _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _step9$value, _index, Element, _v3, index, v;

    return _regeneratorRuntime.wrap(function _callee4$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (Array.isArray(value)) {
              _context10.next = 4;
              break;
            }

            _context10.next = 3;
            return ctx.fail();

          case 3:
            return _context10.abrupt("return");

          case 4:
            _iteratorNormalCompletion9 = true;
            _didIteratorError9 = false;
            _iteratorError9 = undefined;
            _context10.prev = 7;
            _iterator9 = Elements.entries()[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
              _context10.next = 16;
              break;
            }

            _step9$value = _slicedToArray(_step9.value, 2), _index = _step9$value[0], Element = _step9$value[1];
            _v3 = value[_index];
            return _context10.delegateYield(ctx.check(_v3, Element, value, _index), "t0", 13);

          case 13:
            _iteratorNormalCompletion9 = true;
            _context10.next = 9;
            break;

          case 16:
            _context10.next = 22;
            break;

          case 18:
            _context10.prev = 18;
            _context10.t1 = _context10["catch"](7);
            _didIteratorError9 = true;
            _iteratorError9 = _context10.t1;

          case 22:
            _context10.prev = 22;
            _context10.prev = 23;

            if (!_iteratorNormalCompletion9 && _iterator9["return"] != null) {
              _iterator9["return"]();
            }

          case 25:
            _context10.prev = 25;

            if (!_didIteratorError9) {
              _context10.next = 28;
              break;
            }

            throw _iteratorError9;

          case 28:
            return _context10.finish(25);

          case 29:
            return _context10.finish(22);

          case 30:
            if (!(value.length > Elements.length)) {
              _context10.next = 34;
              break;
            }

            index = Elements.length;
            v = value[index];
            return _context10.delegateYield(ctx.check(v, Never, value, index), "t2", 34);

          case 34:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee4, null, [[7, 18, 22, 30], [23,, 25, 29]]);
  }));
}
/**
 * Validate that a value matches a specific strutural interface, like the
 * structural typing that TypeScript uses.
 */


function type(Structs) {
  var keys = Object.keys(Structs);
  return struct("Type<{".concat(keys.join(','), "}>"), /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(value, ctx) {
    var _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, key, Value, v;

    return _regeneratorRuntime.wrap(function _callee5$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(typeof value !== 'object' || value == null)) {
              _context11.next = 4;
              break;
            }

            _context11.next = 3;
            return ctx.fail();

          case 3:
            return _context11.abrupt("return");

          case 4:
            _iteratorNormalCompletion10 = true;
            _didIteratorError10 = false;
            _iteratorError10 = undefined;
            _context11.prev = 7;
            _iterator10 = keys[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
              _context11.next = 17;
              break;
            }

            key = _step10.value;
            Value = Structs[key];
            v = value[key];
            return _context11.delegateYield(ctx.check(v, Value, value, key), "t0", 14);

          case 14:
            _iteratorNormalCompletion10 = true;
            _context11.next = 9;
            break;

          case 17:
            _context11.next = 23;
            break;

          case 19:
            _context11.prev = 19;
            _context11.t1 = _context11["catch"](7);
            _didIteratorError10 = true;
            _iteratorError10 = _context11.t1;

          case 23:
            _context11.prev = 23;
            _context11.prev = 24;

            if (!_iteratorNormalCompletion10 && _iterator10["return"] != null) {
              _iterator10["return"]();
            }

          case 26:
            _context11.prev = 26;

            if (!_didIteratorError10) {
              _context11.next = 29;
              break;
            }

            throw _iteratorError10;

          case 29:
            return _context11.finish(26);

          case 30:
            return _context11.finish(23);

          case 31:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee5, null, [[7, 19, 23, 31], [24,, 26, 30]]);
  }));
}

function union(Structs) {
  return struct("".concat(Structs.map(function (s) {
    return s.type;
  }).join(' | ')), /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(value, ctx) {
    var _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, S, _ctx$check3, _ctx$check4, failures;

    return _regeneratorRuntime.wrap(function _callee6$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _iteratorNormalCompletion11 = true;
            _didIteratorError11 = false;
            _iteratorError11 = undefined;
            _context12.prev = 3;
            _iterator11 = Structs[Symbol.iterator]();

          case 5:
            if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
              _context12.next = 13;
              break;
            }

            S = _step11.value;
            _ctx$check3 = ctx.check(value, S), _ctx$check4 = _toArray(_ctx$check3), failures = _ctx$check4.slice(0);

            if (!(failures.length === 0)) {
              _context12.next = 10;
              break;
            }

            return _context12.abrupt("return");

          case 10:
            _iteratorNormalCompletion11 = true;
            _context12.next = 5;
            break;

          case 13:
            _context12.next = 19;
            break;

          case 15:
            _context12.prev = 15;
            _context12.t0 = _context12["catch"](3);
            _didIteratorError11 = true;
            _iteratorError11 = _context12.t0;

          case 19:
            _context12.prev = 19;
            _context12.prev = 20;

            if (!_iteratorNormalCompletion11 && _iterator11["return"] != null) {
              _iterator11["return"]();
            }

          case 22:
            _context12.prev = 22;

            if (!_didIteratorError11) {
              _context12.next = 25;
              break;
            }

            throw _iteratorError11;

          case 25:
            return _context12.finish(22);

          case 26:
            return _context12.finish(19);

          case 27:
            _context12.next = 29;
            return ctx.fail();

          case 29:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee6, null, [[3, 15, 19, 27], [20,, 22, 26]]);
  }));
}
/**
 * Convert a value to a literal string.
 */


function toLiteralString(value) {
  return typeof value === 'string' ? "\"".concat(value.replace(/"/g, '"'), "\"") : "".concat(value);
}
/**
 * Coerce the values of an object-like struct.
 */


function createObjectCoercer(Structs) {
  var knowns = Object.keys(Structs);
  return function (value) {
    if (typeof value !== 'object' || value == null) {
      return value;
    }

    var ret = {};
    var unknowns = new Set(Object.keys(value));
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = knowns[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var key = _step12.value;
        unknowns["delete"](key);
        var Value = Structs[key];
        var v = value[key];
        ret[key] = coerce(v, Value);
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12["return"] != null) {
          _iterator12["return"]();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }

    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
      for (var _iterator13 = unknowns[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
        var _key3 = _step13.value;
        ret[_key3] = value[_key3];
      }
    } catch (err) {
      _didIteratorError13 = true;
      _iteratorError13 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion13 && _iterator13["return"] != null) {
          _iterator13["return"]();
        }
      } finally {
        if (_didIteratorError13) {
          throw _iteratorError13;
        }
      }
    }

    return ret;
  };
}

export { Struct, StructError, any, array, assert, _boolean as boolean, coerce, coercion, date, defaulted, dynamic, empty, enums, func, instance, intersection, is, lazy, length, literal, map, masked, never, nullable, number, object, optional, partial, pattern, record, refinement, set, string, struct, tuple, type, union, validate };